import React from 'react'
import dynamic from 'next/dynamic'

import { TypeAssetLottieInteractiveAnimation } from '@lib/types'
import { ContentProps, ContentRenderer } from '../../renderer'
import { updateAssetCDNUrl } from '../utils'
import { useInteractiveLottieGnarTracking } from '../lottie/hooks'

const DynamicInteractiveLottiePlayer = dynamic(
  () => import('../lottie/players/interactive-lottie-player').then((m) => m.InteractiveLottiePlayer),
  { ssr: false }
)

export const LottieInteractiveAnimationAsset: React.FC<ContentProps<TypeAssetLottieInteractiveAnimation>> = (props) => {
  const { className, structure } = props
  const { jsonUrl, description, placeholderImage, fallbackVideo, ctAs, internalName } = structure.fields
  const gnarTracking = useInteractiveLottieGnarTracking()

  return (
    <div className={className} data-component-id={internalName}>
      <DynamicInteractiveLottiePlayer
        jsonUrl={jsonUrl}
        description={description}
        fallbackImage={
          placeholderImage?.fields?.file && {
            url: updateAssetCDNUrl(placeholderImage.fields.file.url),
            alt: placeholderImage.fields.description,
          }
        }
        fallbackVideo={fallbackVideo.fields.file}
        cta={<ContentRenderer structure={ctAs} />}
        events={gnarTracking}
      />
    </div>
  )
}
